import * as React from "react";
import { Button, Text, Flex } from "@chakra-ui/react";
import { flexRender, Header, HeaderGroup, Row } from '@tanstack/react-table';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend'
import { DataTableProps } from "./Table.types";
import TableHeader from "./components/TableHeader";
import { BsPlus } from "react-icons/bs";
import DraggableRow from "./components/DraggableRow";

export default function DataTable({
    columns,
    onAddRow,
    reorderRow,
    ...props
}: DataTableProps) {
    const {
        properties, getHeaderGroups,
        onPropertyUpdate, onPropertyDelete, 
        onPropertyDuplicate, getPaginationRowModel, getRowModel
    } = props as any;

    const [isDragIconShow, setIsDragIconShow] = React.useState(true);

    function handleDragNDropShow(val: boolean) {
        setIsDragIconShow(val)
    }
        
    return (
        <DndProvider backend={HTML5Backend}>
            <table className='custom-table'>
                <thead>
                    {getHeaderGroups().map((headerGroup: HeaderGroup<{}>) => (
                        <tr key={headerGroup.id}>
                            {headerGroup.headers.map((header:  Header<{}, unknown>) => (                                                                
                                <th 
                                    key={header.id} 
                                    colSpan={header.colSpan} 
                                    style={{ width: header.id === 'select' || header.id === 'new' ? '5%' : 'fit' }}
                                    className='custom-table-th'
                                >
                                    {header.id !== 'new' && header.id !== 'select' ? (
                                        <TableHeader 
                                            id={header.id} 
                                            {...{
                                                properties,
                                                onPropertyUpdate,
                                                onPropertyDelete,
                                                onPropertyDuplicate
                                            }}
                                        /> 
                                    ): (
                                        flexRender(header.column.columnDef.header, header.getContext()) 
                                    )}
                                </th>
                            ))}
                        </tr>
                    ))}
                </thead>

                <tbody>
                    {getPaginationRowModel().rows.map((row: Row<{}>) => (
                        <DraggableRow  
                            key={row.id} 
                            row={row} 
                            reorderRow={reorderRow!} 
                            isDragIconShow={isDragIconShow}
                            onHoverShow={(val: boolean) => handleDragNDropShow(val)} 
                        />
                    ))}
                </tbody>

                <tfoot className="tfoot">
                    {onAddRow && (
                        <tr style={{ borderTop: "1px solid rgba(144, 164, 183, 0.22)" }}>
                            <td
                                style={{ width:"300px", padding: "0.25rem", borderRight: "1px solid rgba(144, 164, 183, 0.22)" }}
                            >
                                <Button
                                    size="xs"
                                    width="100%"
                                    leftIcon={<BsPlus />}
                                    variant="ghost"
                                    onClick={onAddRow}
                                >
                                    New
                                </Button>
                            </td>
                        </tr>
                    )}
                    <tr
                        style={{ borderTop: "1px solid rgba(144, 164, 183, 0.22)", borderBottom: "1px solid rgba(144, 164, 183, 0.22)" }}
                    >
                        <td
                            style={{ width:"300px", padding: "0.5rem 0.25rem", borderRight: "1px solid rgba(144, 164, 183, 0.22)" }}
                        >
                            <Flex alignItems={'center'}>
                                <Text fontSize="xs" fontWeight={'bold'}>Count:</Text>
                                <Text fontSize="sm" marginLeft={'1'} marginRight={'1'}>{getRowModel()?.rows && getRowModel()?.rows.length}</Text>
                            </Flex>
                        </td>
                    </tr>
                </tfoot>
            </table>
        </DndProvider>
    )
}